/* istanbul ignore next */
import PSelect from './src/select';
// import '@/theme-chalk/src/index.scss'

PSelect.install = function(Vue) {
  Vue.component(PSelect.name, PSelect);
};

export default PSelect;
